import fetchData from "../api/Fetch";

const fetchOrganisation = async (organisationID) => {
  let response = await fetchData("organisation/" + organisationID);
  return response;
};

export default fetchOrganisation;
